import { filter, concatMap, delay, bufferTime } from 'rxjs/operators';
import { pipe, from } from 'rxjs';
import { ofType } from '@ngrx/effects';
import {
  DocumentActionTypes,
  DocumentCreated,
  DocumentUpdated,
  DocumentDeleted,
} from './document.actions';
import {
  FireStoreDocument,
  IWithCollectionPath
} from '@digitaix/types';

export function hasCollectionPath<T extends IWithCollectionPath>(
  collectionPath: string,
) {
  return filter<T>((action) => action.collectionPath === collectionPath);
}

export function ofDocumentCreatedType<D extends FireStoreDocument>(
  collectionPath: string,
  notNull: boolean = true,
) {
  return pipe(
    ofType<DocumentCreated<D>>(DocumentActionTypes.Created),
    hasCollectionPath(collectionPath),
    filter((action) => !notNull || action.document !== null),
  );
}

export function ofDocumentUpdatedType<D extends FireStoreDocument>(
  collectionPath: string,
  notNull: boolean = true,
) {
  return pipe(
    ofType<DocumentUpdated<D>>(DocumentActionTypes.Updated),
    hasCollectionPath(collectionPath),
    filter((action) => !notNull || action.document !== null),
  );
}

export function ofDocumentDeletedType(collectionPath: string) {
  return pipe(
    ofType<DocumentDeleted>(DocumentActionTypes.Deleted),
    hasCollectionPath(collectionPath),
  );
}

// TODO : move to utilities package
export function chunk<T>(count: number = 10, time: number = 50) {
  return pipe(
    bufferTime<T>(time, null, count),
    filter((items) => !!items.length),
    concatMap((items: T[]) => from(items).pipe(delay(time))),
  );
}
